import 'core-js/stable'

import Vue from 'vue'
import Vuelidate from 'vuelidate'

import Ls from './services/ls'
import VueButtonSpinner from 'vue-button-spinner'
import { VueMaskDirective } from 'v-mask'
import vSelect from 'vue-select'

/**
 * Global CSS imports
 */
import 'v-autocomplete/dist/v-autocomplete.css'
import 'vue-select/dist/vue-select.css'

global.Vue = Vue

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

global.axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const AUTH_TOKEN = Ls.get('auth.token')

    if (AUTH_TOKEN) {
      config.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`
    }

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

require('./helpers/directives')

Vue.component('vue-button-spinner', VueButtonSpinner)
Vue.component('v-select', vSelect)

Vue.directive('mask', VueMaskDirective)

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.use(Vuelidate)
